// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

const variant1Config = {
  id: '안국약품-sheet1',
  pharmaceuticalCompanyName: '안국약품',
  targetSheetName: 'Sheet1',
  headerRowIndex: 0,
  headerRowCount: 1,
  dataStartRowIndex: 1,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '보험단가',
    commissionRate: '수수료',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '복지부분류',
    '분류',
    '제품명',
    '성분명',
    '보험단가',
    '보험코드',
    '수수료',
    '비고',
  ],
};

const variant2Config = {
  id: '안국약품-table-2',
  pharmaceuticalCompanyName: '안국약품',
  targetSheetName: 'Table 2',
  headerRowIndex: 1,
  headerRowCount: 1,
  dataStartRowIndex: 2,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '보험단가',
    commissionRate: '수수료',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '복지부분류',
    '분류',
    '제품명',
    '성분명',
    '보험단가',
    '보험코드',
    '수수료',
    '비고',
  ],
};

export default [
  createCommissionTemplate(variant1Config),
  createCommissionTemplate(variant2Config),
];
